var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailPreviewContentBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 85,
    viewBox: "0 0 72 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6223_35870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 63.6364,
    height: 77,
    rx: 3,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5459,
    y: 14,
    width: 44.5455,
    height: 4,
    rx: 2,
    fill: "#EEEEEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5488,
    y: 46,
    width: 44.5455,
    height: 3,
    rx: 1.5,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5488,
    y: 51,
    width: 44.5455,
    height: 3,
    rx: 1.5,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5488,
    y: 56,
    width: 29.697,
    height: 3,
    rx: 1.5,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1514,
    y: 64,
    width: 23.3333,
    height: 6,
    rx: 3,
    fill: "#EEEEEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5459,
    y: 21,
    width: 44.5455,
    height: 21,
    rx: 2,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0938 26.405L32.965 30.335L35.3513 33.335C35.7013 33.775 35.6059 34.405 35.1392 34.735C34.6725 35.065 34.0044 34.985 33.6544 34.535C32.5407 33.135 31.2044 31.465 30.3665 30.395C29.9422 29.865 29.0938 29.865 28.6695 30.395L24.4271 35.725C23.9074 36.395 24.4059 37.335 25.2756 37.335H44.3665C45.2362 37.335 45.7347 36.395 45.215 35.735L37.7907 26.405C37.3665 25.865 36.518 25.865 36.0938 26.405V26.405Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6223_35870",
    x: 0,
    y: 0,
    width: 71.6367,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6223_35870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6223_35870",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPreviewContentBody);
export default __webpack_public_path__ + "static/media/email-preview-content-body.1f588855b5517aeefa748efbe6a8c9f4.svg";
export { ForwardRef as ReactComponent };